import React, { useEffect, useState } from "react"

import StoryCardWidget from "../../widgets/storyCardWidget/StoryCardWidget"
import TallCustomCardWidget from "../../widgets/tallCustomCardWidget/TallCustomCardWidget"
import { BackgroundKeyToColor, GeneralSizeKeyToPaddingNumber } from "../../../utils/datasources"

import * as styles from "./MasonryGridPanel.module.scss"



const Components = {
  "story_card_widget": StoryCardWidget,
  "tall_custom_card_widget": TallCustomCardWidget
}

// Bootstrap Reference
// XS < 576
// S < 768
// M < 992
// L < 1200
const MOBILE_BREAKPOINT = 576,
      TABLET_BREAKPOINT = 992;
function MasonryGridPanel({ blok }) {
  const [screenWidth,setScreenWidth] = useState(1200),
        [numColumns,setNumColumns] = useState(3)
  const backgroundColor = BackgroundKeyToColor(blok.background_color),
        paddingTop = GeneralSizeKeyToPaddingNumber(blok.padding_top),
        paddingBottom = GeneralSizeKeyToPaddingNumber(blok.padding_bottom),
        headingPadding = GeneralSizeKeyToPaddingNumber(blok.heading_padding)

  function handleResize(e) {
    setScreenWidth(window.innerWidth)
  }

  useEffect(()=>{
    let newCount = 3;
    if(screenWidth < MOBILE_BREAKPOINT) {
      newCount = 1
    } else if (screenWidth < TABLET_BREAKPOINT) {
      newCount = 2
    }
    setNumColumns(newCount)
  },[screenWidth])

  useEffect(()=>{
    window.addEventListener("resize", handleResize)
    setScreenWidth(window.innerWidth)
    return () =>{ window.removeEventListener("resize", handleResize) }
  },[])


  return (
    <section style={{ backgroundColor, paddingTop, paddingBottom }}>
      <div className="content-limits">
        {blok.heading ? <h3 className={styles.heading} style={{paddingBottom: headingPadding}}>{blok.heading}</h3> : null}
        <div className={styles.desktopLayout}>
          {[...Array(numColumns)].map((c,colIdx)=>{
            return (
              <div key={`column_${colIdx}`}>
                {blok.content.filter((i,itemIdx)=>{return itemIdx % numColumns === colIdx}).map((item)=>(
                  <RenderItem key={item._uid} item={item} />
                ))}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

function RenderItem({ item }) {
  const Blok = Components[item.component]

  if(Blok) {
    return (
      <div key={item._uid} className="masonry-grid-item">
        <Blok blok={item} />
      </div>
    )
  } else {
    return (
      <div key={item._uid} className="masonry-grid-item">
        <p>[{item.component}] Not Supported</p>
      </div>
    )
  }
}

export default MasonryGridPanel